export default "__VITE_ASSET__513fa2a2__"